//  React TS Base Styles
import colors from '../../base/colors'

//  React TS Helper Functions
import pxToRem from '../../functions/pxToRem'

const { transparent } = colors

// types
type Types = any

const select: Types = {
  styleOverrides: {
    select: {
      display: 'grid',
      alignItems: 'center',
      padding: `0 ${pxToRem(12)} !important`,

      '& .Mui-selected': {
        backgroundColor: transparent.main,
      },
    },

    selectMenu: {
      background: 'none',
      height: 'none',
      minHeight: 'none',
      overflow: 'unset',
    },
  },
}

export default select
